var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"23","height":"14","viewBox":"0 0 23 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.153 7.373L13.221 13.115L13.814 13.815L22.103 6.888L13.814 0L13.22 0.699997L20.154 6.44301H0V7.364H20.153V7.373Z","fill":"#1C65AC"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }